import { Link } from "react-router-dom";

export const MarketingFooter = () => (
  <footer className="relative border-t border-slate-200 bg-white pt-20 pb-0 overflow-hidden" data-testid="landing-footer">
    <div className="max-w-7xl mx-auto px-5 lg:px-10 grid grid-cols-2 md:grid-cols-4 gap-10 pb-16">
      <div className="col-span-2 md:col-span-1">
        <img src="/brand/logo-horizontal-t.png" alt="FulfillFlow" className="h-9 w-auto object-contain" />
        <p className="mt-4 text-sm text-slate-500 leading-relaxed">
          The multi-tenant operations platform for modern 3PL warehouses.
        </p>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-slate-400 font-semibold mb-4">Product</p>
        <ul className="space-y-2.5 text-[15px] text-slate-600">
          <li><Link to="/features" className="hover:text-blue-600 transition-colors">Features</Link></li>
          <li><Link to="/pricing" className="hover:text-blue-600 transition-colors">Pricing</Link></li>
        </ul>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-slate-400 font-semibold mb-4">Account</p>
        <ul className="space-y-2.5 text-[15px] text-slate-600">
          <li><Link to="/login" className="hover:text-blue-600 transition-colors" data-testid="footer-signin-link">Sign In</Link></li>
          <li><Link to="/contact" className="hover:text-blue-600 transition-colors">Request Demo</Link></li>
        </ul>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-slate-400 font-semibold mb-4">Contact</p>
        <ul className="space-y-2.5 text-[15px] text-slate-600">
          <li><a href="mailto:info@fulfillflow.io" className="hover:text-blue-600 transition-colors">info@fulfillflow.io</a></li>
          <li><span>fulfillflow.io</span></li>
        </ul>
      </div>
    </div>
    <p className="max-w-7xl mx-auto px-5 lg:px-10 pb-8 text-xs text-slate-400">
      © {new Date().getFullYear()} FulfillFlow. All rights reserved.
    </p>
    <p aria-hidden="true" className="lp-display text-[13vw] font-bold leading-none text-transparent bg-gradient-to-b from-blue-600/10 to-blue-600/0 bg-clip-text text-center select-none -mb-[2vw]">
      FULFILLFLOW
    </p>
  </footer>
);
